// extracted by mini-css-extract-plugin
export default {"lotValue":"Semaine_lotValue__B-O-L","smallTitle":"Semaine_smallTitle__Cvd7t"};